import EntryStatusHandler from './entryStatusHandler';
import SearchShipmentHandler from './searchShipmentHandler';

// Export classes for creating custom instances
export { default as EntryStatusHandler } from './entryStatusHandler';
export { default as SearchShipmentHandler } from './searchShipmentHandler';
export { default as BaseHandler } from './baseHandler';

export * from './utils';

// ============================================================================
// GLOBAL SINGLETON INSTANCES
// ============================================================================

let entryStatusHandler = null;
let searchShipmentHandler = null;
let socketClientInstance = null;

//  Initialize handlers with a socket client instance
//  Must be called before using convenience functions
export const initHandlers = (socketClient) => {
  socketClientInstance = socketClient;
  entryStatusHandler = new EntryStatusHandler(socketClient);
  searchShipmentHandler = new SearchShipmentHandler(socketClient);
};

//  Gets the entry status handler singleton
const getEntryStatusHandler = () => {
  if (!entryStatusHandler) {
    throw new Error('Handlers not initialized. Call initHandlers(socketClient) first.');
  }
  return entryStatusHandler;
};

//  Gets the search shipment handler singleton
const getSearchShipmentHandler = () => {
  if (!searchShipmentHandler) {
    throw new Error('Handlers not initialized. Call initHandlers(socketClient) first.');
  }
  return searchShipmentHandler;
};


//  Starts listening to entry status updates
export const startEntryStatusListening = (shipmentId, token, callback, options = {}) => {
  getEntryStatusHandler().startListening(shipmentId, token, callback, options);
};

//  Stops listening to entry status updates
export const stopEntryStatusListening = () => {
  if (entryStatusHandler) {
    entryStatusHandler.stopListening();
  }
};

/**
 * Starts listening to broker shipment search updates for a single shipment
 */
export const startBrokerShipmentListening = (shipmentId, token, callback) => {
  getSearchShipmentHandler().startListening(shipmentId, token, callback);
};

//  Stops listening to broker shipment search updates
export const stopBrokerShipmentListening = () => {
  if (searchShipmentHandler) {
    searchShipmentHandler.stopListening();
  }
};

//  Gets the socket client instance
export const getSocketClient = () => {
  return socketClientInstance;
};
